import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PortHdmiIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_313"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_313)">
        <path
          d="M13.7273 5H2.27273C1.57273 5 1 5.57273 1 6.27273V9.45455C1 10.1545 1.57273 10.7273 2.27273 10.7273H2.90909L3.8 11.6182C4.05455 11.8727 4.37273 12 4.69091 12H11.2455C11.5636 12 11.8818 11.8727 12.1364 11.6182L13.0909 10.7273H13.7273C14.4273 10.7273 15 10.1545 15 9.45455V6.27273C15 5.57273 14.4273 5 13.7273 5ZM2.27273 9.45455V6.27273H13.7273V9.45455H12.5818L11.3091 10.7273H4.69091L3.41818 9.45455H2.27273ZM12.4545 7.54545H3.54545V8.81818H12.4545V7.54545Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortHdmiIcon.displayName = 'PortHdmiIcon';
